export const LINKS = {
  customerWebApp: 'https://app.yabathoplatform.co.za',
  adminDashboard: 'https://admin.yabathoplatform.co.za',
  playStore:
    'https://play.google.com/store/apps/details?id=com.yabathocustomerapp',
  appGallery: 'https://appgallery.huawei.com/#/app/C115438149',
  appStore: 'https://apps.apple.com/za/app/yabatho-customer/id6770648514',
  adminEmail: 'admin@yabathoplatform.co.za',
  supportEmail: 'support@yabathoplatform.co.za',
  partnershipsEmail: 'partnerships@yabathoplatform.co.za',
};

export function openExternalLink(url) {
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function requestPartnerAccess(audience) {
  const subject = encodeURIComponent(`YaBatho ${audience} access`);
  const body = encodeURIComponent(
    `Hello YaBatho team,\n\nI would like ${audience.toLowerCase()} access for the YaBatho platform.\n\nName:\nBusiness / rider details:\nPhone number:\n\nThank you.`,
  );

  window.location.href = `mailto:${LINKS.supportEmail}?subject=${subject}&body=${body}`;
}
